export default {
    id: 'yellow-green-blue',
    colors: ['#FFC533', '#64D1B4', '#69B6FF'],
};
